<template>
    <div>
        <div class="clearbox"></div> 
        <img class="bannerbox"  src="../../static/images/banner2.jpg" /> 
        <div class="clearbox"></div>
        
        <div class="contentlist"> 
            <div class="index-width"> 
                <div class="listbox-left"> 
                    <div class="position">
                        <span>当前位置：<a ><router-link to="/">首页</router-link></a>&nbsp;&gt;&gt;&nbsp;<a @click="gotoType('businessArea')">业务领域</a>&nbsp;&gt;&gt;&nbsp;<a ><router-link to="">{{thirdTitle}}</router-link></a></span>
                    </div> 
                    <div class="Articlebox">
                        <h1>{{details.title}}</h1>
                        <div class="a-text-c">
                            <div v-html="details.text"> 
                               
                            </div> 
                        </div>
                    </div>

                </div> 
                
                <boxRight :mainTitle="mainTitle" :liData="liData" @routerData="routerData"></boxRight>
            </div> 
        </div> 
        <div class="clearbox"></div> 
        <footerNew></footerNew>
    </div>
</template>

<script>
    import boxRight from '@/component/listBoxRight.vue'
    import footerNew from '@/component/footerNew.vue'
    export default {
        components:{
			boxRight,
            footerNew					
		},
        name: "areaDetails",
        data(){
            return{
                mainTitle:"业务领域",
                liData:[
                    {name:"充电桩生产及销售业务",routerTo:"news",id:"1",type:"1",classification:'4-1'},
                    {name:"充电桩建设及运营业务",routerTo:"news",id:"2",type:"2",isActive:false,classification:'4-2'},
                    {name:"传感光伏业务",routerTo:"news",type:"3",id:"3",isActive:false,classification:'4-3'},
                    {name:"BIPV(光伏)业务",routerTo:"news",type:"4",id:"4",isActive:false,classification:'4-4'},
                    {name:"共享出行分时租赁",routerTo:"news",type:"5",id:"5",isActive:false,classification:'4-5'},
                    {name:"充电运营平台小程序解决方案",routerTo:"news",id:"6",type:"6",isActive:false,classification:'4-6'},
                ],
                thirdTitle:"",
                details:{
                    id:'1',title:"",text:""
                },
                detailsData:[
                    {id:"1",title:"充电桩生产及销售业务",text:'<p><span style="color: rgb(51, 51, 51); font-family: Arial; background-color: rgb(255, 255, 255);"> 集团拥有独立的充电桩研发、生产能力，充电桩产品水平世界领先。自主研发的充电桩产品具有智能性强，安全性高等特点，通过最严苛的美国UL、欧盟CE、中国国标等认证，兼容性符合国际，欧美SAE Combo等快速充电标准，能够与国内外所有主流新能源汽车完成充电协议对标。</span><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><span style="color: rgb(51, 51, 51); font-family: Arial; background-color: rgb(255, 255, 255);">产品展示</span><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585989962.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 800px;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585890982.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 800px;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585631266.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 800px;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585610016.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 800px;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585270289.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 800px;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585260476.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 800px;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/09ed4455-3625-4b79-90c7-487b80191699.png" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); height: 397px; width: 800px;"><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/d53266d5-7485-4237-9610-0e1d3f6253d9.png" style="margin-top: 20px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; height: 497px; width: 300px;"><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/220cdc3a-e64b-421d-b13d-bc6834e6bc46.png" style="margin-top: 20px;margin-left:20px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; height: 497px; width: 300px;"></p> '},
                    {id:"2",title:"充电站建设及运营业务",text:'<p><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; background-color: rgb(255, 255, 255);">配电及充电系统：充电站核心内容，配电系统（配电室、分配电箱、线缆等）及充电设备的安装与施工<br>监控安防系统：为满足充电站区域的安全目标，根据实际现场情况设置机位实际定点<br>站点导视\视觉系统：针对充电站所在停车场区域的导示导引系统，以及广告、服务相关的信息展示系统<br>充电站运营系统：基于充电站整体运营的支持系统，包括内部运营平台、结算系统、实际运营所需的相关物资、人力与技术支持。</span><br style="color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/275357f8-555c-4db9-bec0-53061f21dcc0.png" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); width: 652px; height: 354px;"></p> '},
                    {id:"3",title:"传统光伏业务",text:'<p style="line-height: 16px;"><a style="font-size:12px; color:#0066cc;" href="/uploads/common/1611826040769928.png" title="APP下载二维码.png"></a></p><p style="line-height: 16px;"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px;">传统能源、燃料成本将会呈持续增长的趋势，光伏发电可以明显的提高效率和降低成本。</span><br></p><p><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px; background-color: rgb(255, 255, 255);">光伏系统的主要功能：</span><br style="color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);"></p><p><span style="margin: 0px; padding: 0px; border: 0px;">•减少火电用量，分担用电负荷；优化能源利用，削峰填谷。</span></p> <p><span style="margin: 0px; padding: 0px; border: 0px;">•遮阳隔热，降低空调费用；隔音、不透水、可对抗恶劣天气；可加入智能电网，实现能源互联。</span></p> <p><span style="margin: 0px; padding: 0px; border: 0px;">•光伏发电＋充电站＝100%清洁能源</span><br>&nbsp;</p><p><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/9833a477-6faa-4ca5-9256-eb3d3c551376.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px; color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); width: 754px; height: 285px;"></p><p><br></p>'},
                    {id:"4",title:"BIPV(光伏)业务",text:'<p class="ordinary-output target-output clearfix" style="margin-top: 0px; margin-bottom: 0px; padding: 0px; border: 0px;"><span style="margin: 0px; padding: 0px; border: 0px;"> 旗下的德国Asola是全球仅有的3家有能力生产太阳能屋顶系统的公司之一，旗下Asola VITRUM系列产品是不同于传统光伏的新型材料。Asola VITRUM作为BIPV是对传统光伏的升级，形成了一种性能优良的建筑材料。</span></p><p class="ordinary-output target-output clearfix" style="margin-top: 0px; margin-bottom: 0px; padding: 0px; border: 0px; text-align: center;"><br>&nbsp;</p><p class="ordinary-output target-output clearfix" style="margin-top: 0px; margin-bottom: 0px; padding: 0px; border: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br><span style="margin: 0px; padding: 0px; border: 0px;">BIPV本身具有隔音、隔热、防爆、防风、防水、防潮、防恶劣天气等特质，作为建筑材料，其牢固程度经得起考验，作为幕墙或天台顶棚都完全达标。同时，作为升级版，BIPV也具备传统光伏的光电转化功能，最高转化率可达22%，白天充分吸收太阳能并进行储存，以起到辅助能源供应之用。</span><br>&nbsp;</p><p></p><p><br></p>'},
                    {id:"5",title:"分时租赁业务",text:'<p><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; background-color: rgb(255, 255, 255);">电动汽车分时租赁是新能源汽车生态网络的商业延伸。相比传统汽车租赁的商业模式，电动汽车分时租赁不但降低了出行成本，同时也提升了消费者乃至全社会的节能环保意识，推动了新能源产业链的发展。</span><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; background-color: rgb(255, 255, 255);"> 集团旗下分时租赁品牌“小易租车”基于 集团在充电运营领域、网络资源、以及品牌方面的优势，打造了独有的“车+桩+充电+停车”运营模式，为用户带去了极佳的体验。<br><img alt="" src="http://picture.telluspowergreen.cn/uploads/common/20201217/1608186535134552.png" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; max-width: 700px;"><br>2016年年底， 集团与顺义区签订了战略合作框架协议，将联合政府打造北京乃至全国电动汽车分时租赁示范基地。未来2-3年，预计在顺义区陆续投入超过1000辆新能源汽车。打造满足居民出行、公务出行、商务出行等多元化绿色出行整体解决方案，为顺义区乃至首都产业转型升级提供了强大助推力。</span></p> '},
                    {id:"6",title:"充电运营平台小程序解决方案",text:'<p><span style="color: rgb(71, 82, 93); font-family: Helvetica, Arial, &quot;Hiragino Sans GB&quot;, &quot;Source Han Sans CN&quot;, Roboto, &quot;Microsoft Yahei&quot;, sans-serif; font-size: 14px; background-color: rgb(255, 255, 255);">《小易出行》是一款电动汽车充电小程序，让用户可以快速找到附近充电桩，支持导航，帮助用户快速找到充电站，为爱车充电。</span></p>'},
                ],
                id:"",
            }
        },
        watch:{
            $route(to,from){
                console.log(to,from)
                this.initData(to.query.id)
            }
        },
        activated(){
            console.log("55555")
            
        },
        created(e){
            console.log(this.$route.query)
            let data = this.$route.query
            let id = ""         
            id = data.data.id
            this.detailsData.map((item,index)=>{
                if(item.id == id){
                    this.details = item
                    this.thirdTitle = item.title
                }
            })
            this.liData.map((item,index)=>{
                if(item.id == id){
                    item["isActive"] = true
                }else{
                    item["isActive"] = false
                }
            })

        },
        methods:{
            initData(id){
                console.log(id)
                this.detailsData.map((item,index)=>{
                    if(item.id == id){
                        this.details = item
                        this.thirdTitle = item.title
                    }
                })
                this.liData.map((item,index)=>{
                    if(item.id == id){
                        item["isActive"] = true
                    }else{
                        item["isActive"] = false
                    }
                })
            },
            routerData(e){
                console.log(e)
                this.detailsData.map((item,index)=>{
                    if(item.id == e.id){
                        this.details = item
                        this.thirdTitle = item.title
                    }                   
                })
                this.liData.map((item,index)=>{
                    if(item.id == e.id){
                        item["isActive"] = true
                    }else{
                        item["isActive"] = false
                    }
                })
                this.$store.commit('newSet',e.classification)
            },
            gotoType(e){
                this.$router.push({path: e});
                this.$store.commit('newSet','4-7') 
            }
        }
    }
</script>

<style scoped>
.text-c {
    text-align: center;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h2 {
    font-size: 14px;
    color: #CCC;
    display: block;
    line-height: 22px;
    text-align: center;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
.contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
     ul, ol, li {
    list-style: none;
}
#pages {
    padding: 14px 0 10px;
    font-family: 宋体;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
}
.text-c {
    text-align: center;
}
.contentlist .listbox-left ul.list_c {
    width: 100%;
    float: left;
    margin: 15px 0;
    overflow: hidden;
}
.contentlist .listbox-left ul.list_c li a {
    float: left;
    font-size: 14px;
    color: #333333;
}
.contentlist .listbox-left ul.list_c li a:hover {
   
    color: #18D1BB;
}
.contentlist .listbox-left ul.list_c li span {
    color: #898989;
    font-size: 14px;
    float: right;
}
.contentlist .listbox-left ul.list_c li {
    width: 100%;
    float: left;
    line-height: 30px;
    box-sizing: border-box;
}
  .footerbox .fott-box2 {
    width: 100%;
    float: left;
    height: 50px;
}
.footerbox .fott-box2 .box2-right span {
    font-size: 14px;
    color: #181818;
    margin: 0 15px;
}
.footerbox .fott-box2 .box2-right {
    float: right;
    line-height: 50px;
    color: #e4e4e4;
    font-family: Tahoma;
}
  .contentlist .listbox-right {
    float: right;
    width: 200px;
}
.contentlist .listbox-right ul li a:hover, .contentlist .listbox-right ul li a.active {
    color: #18D1BB;
}
.contentlist .listbox-right ul li a {
    float: left;
    font-size: 14px;
    color: #000;
}
.contentlist .listbox-right ul li {
    width: 100%;
    float: left;
    line-height: 32px;
    box-sizing: border-box;
    padding-left: 15px;
    background: url(../../static/images/don.gif) no-repeat 5px center;
}
.footerbox {
    margin: 0 auto;
    width: 100%;
    overflow: hidden;
    background: url(../../static/images/bottom_bg.jpg) repeat-x left bottom;
}
.contentlist .listbox-right ul {
    width: 100%;
    float: left;
    margin: 15px 0;
    height: 128px;
}
.contentlist .listbox-right h2 span {
    line-height: 48px;
    font-size: 18px;
    color: #000;
    float: left;
    margin-left: 10px;
}
.contentlist .listbox-right h2 {
    width: 100%;
    height: 48px;
    background-color: #f8f8f8;
    padding: 0 10px;
    box-sizing: border-box;
}
  .contentlist .Articlebox {
    width: 780px;
    float: left;
    min-height: 600px;
}
div, form, ul, ol, li, span, p, dl, dt, dd, img {
    margin: 0;
    padding: 0;
    border: 0;
}
.contentlist .Articlebox .a-text-c {
    font-size: 14px;
    line-height: 28px;
    color: #333333;
    display: block;
    padding: 10px 20px;
    margin-top: 15px;
}
.contentlist .Articlebox h1 {
    display: block;
    padding: 45px 0 5px;
    text-align: center;
    font-size: 19px;
}
  a {
    color: #20366f;
    text-decoration: none;
}
  .position {
    width: 100%;
    float: left;
    border-bottom: 1px solid #dddddd;
    font-family: Tahoma;
    font-size: 14px;
    color: #666666;
    padding: 15px 0;
}
.position a, .position span {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    margin: 0 5px;
}
    .contentlist .listbox-left {
        width: 760px;
        float: left;
    }
  .contentlist {
    margin: 30px auto 15px;
    overflow: hidden;
    width: 100%;
}
.index-width {
    width: 1000px;
    margin: 0 auto;
    position: relative;
}
  .bannerbox {
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 208px;
    object-fit: cover;
}
  .clearbox {
    border-top: 1px solid transparent !important;
    margin-top: -1px !important;
    margin-top: 0px;
    clear: both;
    font-size: 0px;
    line-height: 0px;
    height: 0px;
    border: 0px;
    visibility: hidden;
}
    *{
      box-sizing: border-box;
      margin:0;
      padding:0;
    }
</style>